<script>
	import Layout from "../../layouts/main.vue"
    import Carousel from 'vue-owl-carousel'
    import CenterizeGridBox from '../../components/grid-boxes/CenterizeGridBox.vue'

  	export default {
    	components: { Layout, Carousel, CenterizeGridBox },    

		props: {
            user_details: Object,
            taxReturn: String,
            taxPreparing: String,
            federalTaxRefund: String,
            stateTaxRefund: String,
            adjustedTaxRefund: String,
            workflowDetials: Object
		},
		data() {
			return {
				title: this.$page.props.auth.user.user_type_text + " - Dashboard",
                gridBoxItems: [
                    {
                        viewURL: route('tp-profile-edit'),
                        title: "Edit Profile",
                        icon: '<i class="fas fa-user-edit"></i>'
                    },
                    {
                        viewURL: route('tp-organizer'),
                        title: "Organize Tax Information",
                        icon: '<i class="fas fa-info-circle"></i>'
                    },
                    {
                        viewURL: route('tp-e-signature-list'),
                        title: "Sign Documents",
                        icon: '<i class="fas fa-file-signature"></i>'
                    },
                    {
                        viewURL: route('tp-communications'),
                        title: "Communicate with Tax Company",
                        icon: '<i class="bx bx-chat"></i>'
                    },
                    {
                        viewURL: route('tp-task_management_index'),
                        title: "Manage Tasks",
                        icon: '<i class="bx bx-task"></i>'
                    },
                    {
                        viewURL: route('tp-schedule'),
                        title: "View Schedule",
                        icon: '<i class="bx bx-calendar"></i>'
                    },
                    {
                        viewURL: route('tp-invoice'),
                        title: "Pay Invoice",
                        icon: '<i class="bx bx-receipt"></i>'
                    }
                ]
			};
		},
		computed: {
            userID() {
				return this.$page.props.auth.user.user_id;
			},
			userType() {
				return this.$page.props.auth.user.user_type;
			},
			userTypeAbbr() {
				return this.$page.props.auth.user.user_type_abbr;
			}
            
		},
        methods: {
            changeButtonText(refItem, redirectTo) {
                this.$refs[refItem][0].disabled = true
                this.$refs[refItem][0].innerText = 'Loading...'
                window.location.href = redirectTo
            }
        }
  	}
</script>

<template>
  	<Layout>
		<Head :title="title" />
		<!-- start page title -->
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0 font-size-18">Dashboard</h4>
				</div>
			</div>
		</div>
        <div class="row">
            <div class="col-xl-8">
                <div v-if="workflowDetials && workflowDetials.tasksDetails" class="card overflow-hidden">
                    <h4 class="card-title p-2">{{ workflowDetials.name }}</h4>
                    <carousel 
                        :items="workflowDetials.tasksDetails.length >= 2 ? 2 : workflowDetials.tasksDetails.length" 
                        :nav="false" 
                        :responsive="{ 0:{items: 1}, 601:{items: 2} }">
                        <div v-for="(task, index) in workflowDetials.tasksDetails" class="card-body text-center" :key="index">
                            <div class="row justify-content-center">
                                <div class="text-muted font-size-17">
                                    {{ task.name }}
                                </div>
                            </div>
                            <div class="pt-2 pb-2" :class="'text-' + task.textColor">
                                <i :class="task.taskIcon" style="font-size: 25px;"></i>
                            </div>
                            <div class="row justify-content-center pt-2 pb-2">
                                <h5 :class="'text-' + task.textColor" style="font-size: 14px;">{{ task.statusName }}</h5>
                                <p class="text-muted font-size-14 mb-4">
                                    {{ task.taskDescriptions }}
                                </p>
                                <div class="col-xl-8">
                                    <button 
                                        v-if="[1, 2].includes(task.taskStatusId) && task.ownerId == userID && task.buttonColor != null"
                                        class="btn btn-success"
                                        type="button"
                                        :disabled="task.statusName == 'Unavailable'"
                                        :title="task.name"
                                        :ref="'buttonText_' + workflowDetials.id + '_' + task.id"
                                        @click="changeButtonText('buttonText_' + workflowDetials.id + '_' + task.id, task.hrefSRC)"
                                        >
                                        {{ task.buttonText }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </carousel>
                </div>
                <h4 class="card-title">Quick Actions</h4>
                <div class="row">
                    <template v-for="(item, index) in gridBoxItems">
                        <CenterizeGridBox 
                            :key="index"
                            :viewURL="item.viewURL"
                            :title="item.title"
                            :icon="item.icon"
                            mainDivClasses="col-sm-4"
                            minHeightStyle="min-height: 183px;"
                        />
                    </template>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="card">
                    <h5 class="card-header bg-transparent">
                        Tax Status Information
                    </h5>
                    <div class="card-body">
                        <h4 class="card-title">Return</h4>
                        <p class="card-text p-2" v-if="taxReturn.length">
                            {{ taxReturn }} <br>
                            <template v-if="taxPreparing.length">
                                {{ taxPreparing }}
                            </template>
                        </p>
                        <p class="card-text p-2" v-if="!taxReturn.length && !taxPreparing.length">
                            Not Available
                        </p>
                        <h4 class="card-title">Refund</h4>
                        <p class="card-text p-2">
                            <a href="https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp" target="_blank">
                                <i class="fas fa-dollar-sign"></i> &nbsp;&nbsp;Where Is My Refund?
                            </a>
                        </p>
                        <h4 class="card-title">Transcripts</h4>
                        <p class="card-text p-2">
                            <a href="https://sa.www4.irs.gov/icce-core/load/gettrans/pages/availableTranscripts.xhtml" target="_blank">
                                <i class="far fa-hand-pointer"></i> &nbsp;&nbsp;Click To Open
                            </a>
                        </p>
                        <h4 class="card-title">Federal Tax Refund</h4>
                        <p class="card-text p-2" v-html="federalTaxRefund"></p>
                        <h4 class="card-title">State Tax Refund</h4>
                        <p class="card-text p-2" v-html="stateTaxRefund"></p>
                        <h4 class="card-title">Adjusted Gross Income (AGI)</h4>
                        <p class="card-text p-2" v-html="adjustedTaxRefund"></p>
                    </div>
                </div>
            </div>
        </div>        
  	</Layout>
</template>
